/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeDocumentTypeControllerCreateRequest { 
    /**
     * Nombre del tipo (ej. Política). También es el de su carpeta
     */
    name: string;
    /**
     * Código de 2 letras (ej. PO)
     */
    code: string;
    /**
     * Si los documentos nuevos del tipo se pueden descargar por omisión
     */
    allowDownloadDefault?: boolean;
    displayOrder?: number;
    active?: boolean;
}

